import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: true
}

const searchReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SEARCHING:
         return {
             ...state,
             loading : action.val
         }
         default:
         return state;
    }
};

export default searchReducer;